import PropTypes from 'prop-types';
import React from 'react';

const ChangeModel = ({ href }) => (
  <a href={href} className="sl-change-model">
    Change model
  </a>
);

ChangeModel.propTypes = {
  href: PropTypes.string.isRequired,
};

export default ChangeModel;
